import { NAME as name } from './constants';
import { router } from './router';

export const ZakazkaDelbaPP = {
	name,
	router,
};
